var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ti",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 512,
    height: 512,
    fill: "#338af3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 512,
    height: 256,
    fill: "#6da544"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M0,512c0,.041,512-256.008,512-256.008L0,0Z",
    fill: "#d80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M140.986,156.865a83.572,83.572,0,0,0-83.478,83.478v31.3a83.478,83.478,0,0,0,166.956,0v-31.3A83.572,83.572,0,0,0,140.986,156.865ZM193.16,271.647a52.265,52.265,0,0,1-36.522,49.772V287.3l22.147-22.147L156.65,243.017l-.012-7.879V224.69h-31.3v31.3L103.2,278.125l22.132,22.131v21.162a52.266,52.266,0,0,1-36.521-49.772v-31.3a52.174,52.174,0,1,1,104.348,0v31.305Z",
    fill: "#ffda44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTi);
export default __webpack_public_path__ + "static/media/ti.2562f077c9162d30dfbe0df90504590b.svg";
export { ForwardRef as ReactComponent };